var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeSectionDivider2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M539.5 154H0V0H1921V154H1384C1377 154 1361 153.5 1347 140C1332.6 124.8 1321 121.667 1317 122H606C595 122 586.5 125.5 577.5 135C565.1 150.2 547 154 539.5 154Z",
    fill: "url(#paint0_linear_1326_370)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 154H539.5C547 154 565.1 150.2 577.5 135C586.5 125.5 595 122 606 122C614.8 122 1083.67 122 1317 122C1321 121.667 1332.6 124.8 1347 140C1361 153.5 1377 154 1384 154C1389.6 154 1744.33 154 1921 154",
    stroke: "#322966",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1326_370",
    x1: 960.5,
    y1: 52.5,
    x2: 960.5,
    y2: 154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070710"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806277,
    stopColor: "#120C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22153D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSectionDivider2);
export default __webpack_public_path__ + "static/media/shape_section_divider_2.fa61ab9ed78d068dd66c696e86b72eff.svg";
export { ForwardRef as ReactComponent };